//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { labelsQueryKeys } from '@content-drawer/contentDrawerConstants';
import { queryClient } from '@queries/ReactQueryProvider';
import Cuid from '@models/Cuid';
import { IUiaLaunchOptions } from '@react-bridge/wrappers/ng-service-provider-types';
import { SliceNames } from '@redux/SliceNames';
import { createThunk } from '@redux/createThunk';
import { IUIAOpenState } from '@uia/uia-modal/modal-slice-model';

const initialState: IUIAOpenState = {
  isUIAModalOpen: false,
  sharedModerationCuids: [],
};

const { actions, reducer } = createSlice({
  name: SliceNames.UIAModal,
  initialState,
  reducers: {
    setUIAModalOpen(state, action: PayloadAction<boolean>) {
      state.isUIAModalOpen = action.payload;

      if (!action.payload) {
        state.sharedModerationCuids = [];
      }
    },
    setLastUpdateLabels(state, action: PayloadAction<string[] | undefined>) {
      state.lastUpdatedLabels = action.payload;
    },
    setLaunchOptions(state, action: PayloadAction<IUiaLaunchOptions>) {
      state.launchOptions = action.payload;
    },
    markModerationMediaShared(state, action: PayloadAction<Cuid[]>) {
      state.sharedModerationCuids = [
        ...new Set([
          ...(state.sharedModerationCuids ?? []),
          ...action.payload,
        ]),
      ];
    },
  },
});

export const onUIASaveLabels = createThunk(() => async () => {
  queryClient.invalidateQueries({
    queryKey: labelsQueryKeys,
  });
});

export const {
  markModerationMediaShared,
  setLastUpdateLabels,
  setLaunchOptions,
  setUIAModalOpen,
} = actions;

export default reducer;
